import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EqualizingService {
  public equalize(classesToEqual: string[]): void {
    classesToEqual.forEach(targetClass => {
      const elements: HTMLElement[] = [].slice.call(
        document.getElementsByClassName(targetClass)
      );
      if (elements.length > 0) {
        let highestElement = elements[0];
        elements.forEach(element => {
          element.style.minHeight = 'fit-content';
        });
        elements.forEach(element => {
          if (
            element.getBoundingClientRect().height >
            highestElement.getBoundingClientRect().height
          ) {
            highestElement = element;
          }
        });
        elements.forEach(element => {
          element.style.minHeight =
            highestElement.getBoundingClientRect().height + 'px';
        });
      } else {
        console.warn(
          `Failed to find elements of class ${targetClass} for equalizing`
        );
      }
    });
  }
}
